<template>
    <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
    >
        <rect width="16" height="16" fill="url(#pattern0_30_201)" />
        <defs>
            <pattern id="pattern0_30_201" patternContentUnits="objectBoundingBox" width="1" height="1">
                <use xlink:href="#image0_30_201" transform="scale(0.01)" />
            </pattern>
            <image
                id="image0_30_201"
                width="100"
                height="100"
                preserveAspectRatio="none"
                xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAACXBIWXMAAAsTAAALEwEAmpwYAAAA0klEQVR4nO3bsRGCQBCG0etKKYLNTG4TS7Efm7AzHCogYnbF92augf+DiGMMAAAAAAAAAAAAAACAc93W+VwiP04ebrBvdXKOMZY1X0vk5uTxBmu+BIlGD4sgWR9BkKwfXpCsH1uQrB9YkKwfVZCsH1KQBuPFrwaJ+biv8+3Mww32rU4PAgAAAAAAcHU+UM1eH6hcJc1mn3Dd7d0EiQYXFtpecvCGbIJEg6fdG5L1gwqS9SMK0mC4EKR+rLhIED99Zq+fPgEAAAAAAAAAAAAAgPHnvjkd2D6GfzwfAAAAAElFTkSuQmCC"
            />
        </defs>
    </svg>
</template>
